import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import CustomScheduledHeaderReportComponent from 'src/components/reports/custom-scheduled-report-header.component';

const CustomScheduledReport = () => {
  const { t: translate } = useTranslation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [subReportId, setSubReportId] = useState('');

  const [customReportId, setCustomReportId] = useState(null);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const customReportIdParam = searchParams.get('custom_report_id');
    const subTypeIdParam = searchParams.get('sub_report_id');
    if (subTypeIdParam) setSubReportId(subTypeIdParam);
    if (customReportIdParam) {
      setCustomReportId(parseInt(customReportIdParam, 10));
      setLoading(false);
    }
  }, [location.search]);

  const renderComponent = () => {

    // Check if all required parameters are set
    if (loading) {
      return <Typography variant="h6">{translate('scheduled_reports.loading_data')}</Typography>;
    } else {
      return <CustomScheduledHeaderReportComponent customReportId={customReportId}  subReportId={subReportId}/>;
    }
  };

  return (
    <>
      <Helmet>
        <title>{translate('menu.scheduled_reports')}</title>
      </Helmet>
      <Box>{renderComponent()}</Box>
    </>
  );
};

export default CustomScheduledReport;
